export const parseTempInput = (value: string): string => {
  const sign = value[0] === "-" ? "-" : "";
  const positiveValue = value.replace(/\D/g, "");

  return `${sign}${positiveValue}`;
};
